import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const Rule = styled.div`
  padding-top: ${Spacing.S8};
  padding-bottom: ${Spacing.S4};
`

export const TextCenteringWrapper = styled.div`
  align-self: center;
`
